// SPDX-License-Identifier: LicenseRef-Pachamama-Proprietary
// Copyright 2026 Pachamama Studios B.V. All rights reserved.

/**
 * AYNI — a QR code drawn as an SVG, for the links people scan with a
 * phone: a shared room's (`anchorPanel`) and a meeting's invitations
 * (`meetingPanel`). The encoder (`qrcode-generator`) is loaded on demand,
 * so only a page that shows a code downloads it. Black modules with a
 * four-module quiet zone; the host gives it a white background.
 */

/** Draw `text` as a QR code into `host`, replacing what it held. */
export async function drawQr(host: HTMLElement, text: string): Promise<void> {
  const { default: qrcode } = await import('qrcode-generator')
  const qr = qrcode(0, 'M')
  qr.addData(text)
  qr.make()
  const count = qr.getModuleCount()
  const quiet = 4
  const size = count + 2 * quiet
  const NS = 'http://www.w3.org/2000/svg'
  const svg = document.createElementNS(NS, 'svg')
  svg.setAttribute('viewBox', `0 0 ${size} ${size}`)
  svg.setAttribute('shape-rendering', 'crispEdges')
  svg.setAttribute('aria-hidden', 'true')
  let path = ''
  for (let row = 0; row < count; row++) {
    for (let col = 0; col < count; col++) {
      if (qr.isDark(row, col)) path += `M${col + quiet} ${row + quiet}h1v1h-1z`
    }
  }
  const modules = document.createElementNS(NS, 'path')
  modules.setAttribute('d', path)
  modules.setAttribute('fill', '#000')
  svg.appendChild(modules)
  host.replaceChildren(svg)
}
